import type { LambAnalytics } from '../core/sdk';
import type { EcommerceItem } from './product';

const DEFAULT_CURRENCY = 'KRW';

export interface CartEventParams {
  currency?: string;
  value?: number;
  items: EcommerceItem[];
}

function validateCartParams(params: CartEventParams): CartEventParams {
  if (params.value === undefined || params.value === null) {
    if (typeof console !== 'undefined') {
      console.warn('[LambAnalytics] Cart event missing value, defaulting to 0');
    }
  }
  return {
    currency: params.currency ?? DEFAULT_CURRENCY,
    value: params.value ?? 0,
    items: params.items,
  };
}

export class CartTracker {
  private sdk: LambAnalytics;

  constructor(sdk: LambAnalytics) {
    this.sdk = sdk;
  }

  addToCart(params: CartEventParams): void {
    const validated = validateCartParams(params);
    this.sdk.track('add_to_cart', {
      currency: validated.currency,
      value: validated.value,
      items: validated.items,
    });
  }

  removeFromCart(params: CartEventParams): void {
    const validated = validateCartParams(params);
    this.sdk.track('remove_from_cart', {
      currency: validated.currency,
      value: validated.value,
      items: validated.items,
    });
  }

  viewCart(params: CartEventParams): void {
    const validated = validateCartParams(params);
    this.sdk.track('view_cart', {
      currency: validated.currency,
      value: validated.value,
      items: validated.items,
    });
  }
}
